const SET_GAMES = 'set_games';

export default SET_GAMES;
